import clsx from "clsx";
import { FOCUS_TABS, type FocusTab } from "./tabs";

export type { FocusTab };

interface TabStripProps {
  active: FocusTab;
  onSelect: (tab: FocusTab) => void;
}

/**
 * Renders the focus-mode tab strip from the shared FOCUS_TABS registry. Tabs
 * with `ready: false` show a "SOON" badge and don't navigate when clicked.
 */
export function TabStrip({ active, onSelect }: TabStripProps) {
  return (
    <div className="tab-strip">
      {FOCUS_TABS.map((t) => (
        <button
          key={t.id}
          className={clsx(
            "workspace-tab",
            active === t.id && "active",
            !t.ready && "soon",
          )}
          onClick={() => t.ready && onSelect(t.id)}
          title={t.ready ? undefined : "Lands in a later iteration"}
        >
          {t.label}
          {!t.ready && <span className="tab-soon-badge">SOON</span>}
        </button>
      ))}
    </div>
  );
}
